import { render, staticRenderFns } from "./Suporte.vue?vue&type=template&id=27724be8&scoped=true"
import script from "./Suporte.vue?vue&type=script&lang=js"
export * from "./Suporte.vue?vue&type=script&lang=js"
import style0 from "./Suporte.vue?vue&type=style&index=0&id=27724be8&prod&lang=css"
import style1 from "./Suporte.vue?vue&type=style&index=1&id=27724be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27724be8",
  null
  
)

export default component.exports